<template>
  <div class="video-page">
    <mVideo
      :pages="pages"
      :video="video"
      :state = 'state'
      :skipNum = 'skipNum'
      :skipStyle ='{background:"rgba(255,255,255,0.2)",
        color:"rgba(242,217,187,0.8)",
        fontSize:"12px",width:"11%",padding: "1%"
        }'
      @ended = 'videoEnded'
    >
      <div class="loading-text" slot="loading">
        {{loadingNum}}%
      </div>
      <div class="play-btn" slot="playBtn">
        <div  class="play"></div>
        <div  class="play-text">点击探寻</div>
      </div>
    </mVideo>
  </div>
</template>

<script>
  import 'whatwg-fetch'
  const avatar = require('@/assets/avatar.jpg')
  const video = require('@/assets/v1.mp4')
  const loadingSrc= require('@/assets/loading.gif')

export default {
  name: 'Video',
  data () {
    return {
      // mVideo相关参数
      pages: [
        {
          name: 'loading',
          src : loadingSrc,
          width: '60%'
        },
        {
          name: 'playBtn',
          width: '40%',
          clickPlay: true
        }
      ],
      state: 'loading',
      orientation: 'landscape',
      video: {
        src: '',
        playsinline: true,
        type:'video/mp4',
        fit: 'contain',
        background: '#000'
      },
      skipNum:1,
      loadingNum: 0, // loading数字
      loadingTime:0, // loading数字首字母
      timeId: null, // loading的setTimeout timeId
      preloadNum: 0,
      date: null,
      imgLoaded: false, // 图片加载状态
      imgTimeId: null
    }
  },
  mounted() {
    const self = this
    this.date = +new Date()

    // 微信中获取用户头像
    if((/MicroMessenger/ig).test(navigator.userAgent)){
      function checkStatus(response) {
        //alert(response.status)
        if (response.status >= 200 && response.status < 300) {
          return response
        } else {
          var error = new Error(response.statusText)
          error.response = response
          throw error
        }
      }
      function parseJSON(response) {
        // alert('parse'+response)
        return response.json()
      }

      fetch('http://dict.youdao.com/login/acc/co/cq?product=DICT&cf=1',{ method: 'GET',
        credentials: 'include'
      })
        .then(checkStatus)
        .then(parseJSON)
        .then(function(data) {
          if(data.login) {
            self.preloadAvatar(data['imageurl_big'])
          }else {
            throw Error()
          }
        }).catch(function(error) {
            self.preloadAvatar(avatar)
        })
    } else {
      self.preloadAvatar(avatar)
    }

    // 预加载视频
    self.$preloadVideo(video,{
      success(blob) {
        self.video.src = blob || video
        self.videoLoaded(blob)
      },
      error(e) {
        self.videoLoaded()
        console.log(e)
        self.video.src = video
      },
      timeout: 10
    })

   // this.preloadGif()

    // 安卓从全屏退出事件监听
    const $video = document.getElementsByTagName('video')[0]
    $video.addEventListener('x5videoexitfullscreen',() => {
      this.videoEnded()
    })

    // 设置loading
    this.timeId = setTimeout(() => {
      this.loadingTime += 1
      this.setLoading()
    }, 300)
  },
  methods: {
    videoEnded() {
      this.$router.push('/input')
    },
    videoLoaded() {
      // this.preloadNum += 1
     // if (this.preloadNum < 2) return
      // clearTimeout(this.imgTimeId)
      const dur = +new Date() - this.date
      const minTime = 5000
      console.log(dur)
      if(dur < minTime) {
        setTimeout(() => {
          console.log('play')
          this.play()
        }, minTime - dur)
      }else {
        console.log('play')
        this.play()
      }
    },
    play() {
        this.loadingNum = 100
        clearTimeout(this.timeId)
        this.state = 'playBtn'
    },
    setLoading() {
      this.loadingNum = this.loadingTime === 9 ?  Math.min(this.loadingNum + 1 , 99):Math.floor((Math.random()+this.loadingTime) * 10)
      this.timeId = setTimeout(() => {
        this.loadingTime !== 9 && (this.loadingTime += 1)
        this.setLoading()
      }, 800)
    },
    preloadAvatar(src) {
      this.$preloadImg({
        src: src,
        x: 103,
        y: 103,
        h: 55,
        w: 55,
        z: -1
      })
    },
    preloadGif() {
      window.img = new Image()
      img.src = tranSrc
      img.onload = () => {
        this.imgLoaded = true
        this.videoLoaded()
      }
      this.imgTimeId = setTimeout(() => {
        if (!this.imgLoaded) {
          this.videoLoaded()
        }
      }, 10000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.video-page{
    width: 100%;
    height: 100%;
    background: url(../assets/loadingBg.png) 0 0/100% 100% no-repeat;
}
.loading-text {
  position: absolute;
  right:46%;
  top: 45%;
  text-align: right;
  color: #F2D9BB;
  font-size: 0.32rem;
}
.play-btn {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translateX(-50%);
  font-size: 0.3rem;
  text-align: center;
  color: #F2D9BB;
}

.play {
  box-shadow: 0px 0px 60px 20px #F2D9BB;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(242,217,187,0.6);
  display: inline-block;
  margin-bottom: 1rem;
  animation: show 1.5s infinite;
}
@keyframes show {
  50% {  opacity: 0}
  100% { opacity: 1 }
}

</style>



// WEBPACK FOOTER //
// src/pages/Video.vue